import { useId } from "react";
import {
  stateIsCurrent,
  stateIsDisabled,
  stateIsDone,
  stateIsWarning,
  type NavState,
} from "~/services/navigation/navState";
import { getStepStyles } from "./getStepStyles";
import { StepperIcon } from "./StepperIcon";
import { translations } from "~/services/translations/translations";

const getStatusText = (state: NavState) => {
  if (stateIsDone(state)) {
    return translations.navigation.navigationItemFinished.de;
  }
  if (stateIsWarning(state)) {
    return translations.navigation.navigationItemWarning.de;
  }

  return "";
};

export function StepperContent({
  state,
  stepIndex,
  label,
  href,
  totalSteps,
}: Readonly<{
  state: NavState;
  stepIndex: number;
  label: string;
  href: string;
  totalSteps: number;
}>) {
  const iconId = useId();
  const styles = getStepStyles(state);

  const stepNumber = stepIndex + 1;

  const statusText = getStatusText(state);

  const currentText = stateIsCurrent(state) ? "current" : "";

  const extraSpanText = [statusText, currentText].filter(Boolean).join(", ");
  return (
    <a
      href={href}
      className="group w-full p-14 flex gap-8 justify-center items-center text-center no-underline outline-none"
      aria-disabled={stateIsDisabled(state)}
      aria-current={stateIsCurrent(state) ? "step" : undefined}
      aria-describedby={
        stateIsDone(state) || stateIsWarning(state) ? iconId : undefined
      }
    >
      <span className={styles.circle}>
        <StepperIcon state={state} stepIndex={stepIndex} />
      </span>

      <p className={styles.label}>
        <span className="sr-only">
          {`Schritt ${stepNumber} von ${totalSteps}`}
        </span>

        {label}

        <span className="sr-only">{extraSpanText}</span>
      </p>
    </a>
  );
}
